export const DefaultMapCenter = [40.275897, -82.177474];
export const DefaultZoom = 8;
export const StorageConstant = {
  Layers: "layers",
  MapCenter: "mapCenter",
  Zoom: "zoom",
};
